import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { LOCAL, getTimezoneMode, setTimezoneMode } from "helpers/timezone";

// Components that format dates read `mode` from here so they re-render when
// the viewer switches between UTC and local time. The actual formatting goes
// through helpers/timezone.
export const TimezoneContext = createContext({ mode: LOCAL, setMode: () => {} });

export const useTimezone = () => useContext(TimezoneContext);

const TimezoneContextProvider = ({ children }) => {
  const [mode, setModeState] = useState(getTimezoneMode);

  const setMode = useCallback((nextMode) => {
    // update the formatting helpers first so children render with the new zone
    setTimezoneMode(nextMode);
    setModeState(getTimezoneMode());
  }, []);

  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);

  return (
    <TimezoneContext.Provider value={value}>{children}</TimezoneContext.Provider>
  );
};

export default TimezoneContextProvider;
